export default "__VITE_ASSET__Dsy0LkMY__"